import { mapGetters, mapActions } from 'vuex';
import moment from 'moment';
import utilityFunctionsMix from '@/mixins/utilityFunctionsMix';
const userExpensePermission = {
  mixins: [
    utilityFunctionsMix,
  ],
  computed: {
    ...mapGetters('users', ['me', 'myTeamList', 'getMyTeamList', 'userCompanyId']),
    ...mapGetters('selectdate', ['startDate', 'endDate', 'startMonth', 'endMonth', 'startYear']),
  },
  methods: {
    ...mapActions('transactions', ['getTeamSpentTransaction']),
    async getAdminRole(teamId) {
      // view_team_transactions
      let returnRole = 'Employee';
      await this.getMyTeamList.filter((role) => {
        if (role.team.slug === 'all-teams') {
          role.permissions2.forEach((per) => {
            if (per.slug === 'view_team_transactions') {
              returnRole = 'Admin';
            }
          });
        }

        if (role.team.slug !== 'all-teams') {
          if (role.team.id === teamId) {
            role.permissions2.forEach((per) => {
              if (per.slug === 'view_team_transactions') {
                returnRole = 'Admin';
              }
            });
          }
        }
      });
      return returnRole;
    },

    async getAdminRoleArray() {
      let IdArray = [];
      let permissionArray = [];
      let flag = false;

      await this.getMyTeamList.filter((role) => {
        IdArray.push(role.team.id);
        let x = false;
        if (role.team.slug === 'all-teams') {
          role.permissions2.forEach((per) => {
            if (per.slug === 'view_team_transactions') {
              flag = true;
            }
          });
        }

        if (role.team.slug !== 'all-teams') {
          role.permissions2.forEach((per) => {
            if (per.slug === 'view_team_transactions') {
              x = true;
            }
          });
        }
        if (x) {
          permissionArray.push('Admin');
        } else {
          permissionArray.push('Employee');
        }
      });

      //  Admin role
      if (flag) {
        IdArray = [];
        permissionArray = [];
        await this.myTeamList.forEach((item) => {
          IdArray.push(item.id);
          permissionArray.push('Admin');
        });
      }

      return { IdArray, permissionArray };
    },
    async updateMiddleBarTeamData() {
      const userRoleTeam = await this.getAdminRoleArray();
      const dateInLocalTimeZone = this.getDateInLocalZone({startDate: this.startDate, endDate: this.endDate});
      const year = moment(dateInLocalTimeZone.expenseDateLte).format("YYYY");      
      const month = moment(dateInLocalTimeZone.expenseDateLte).format("MM");
      this.getTeamSpentTransaction({
        groupId: userRoleTeam.IdArray,
        companyId: this.userCompanyId,
        userId: this.me.id,
        role: userRoleTeam.permissionArray,
        month: Number(month),
        year: Number(year),
        expenseDateGte: dateInLocalTimeZone.expenseDateGte,
        expenseDateLte: dateInLocalTimeZone.expenseDateLte,
      });
    },

  },
};
export default userExpensePermission;
